// extracted by mini-css-extract-plugin
export var noSpinners = "_sk-6";
export var percentageInput = "_sk-7";
export var variantColor1 = "_sk-0";
export var variantColor2 = "_sk-1";
export var variantColor3 = "_sk-2";
export var variantColor4 = "_sk-3";
export var variantColor5 = "_sk-4";
export var variantColor6 = "_sk-5";